import { render, staticRenderFns } from "./ReportGroupEfficiency.vue?vue&type=template&id=4a48f6c0&"
import script from "./ReportGroupEfficiency.vue?vue&type=script&lang=js&"
export * from "./ReportGroupEfficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports